import * as React from "react";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { utilBlog } from "../../utils/utilBlog";
var iframeStyle = {
    border: "none",
};
var defaultBlogUrl = process.env.REACT_APP_BLOG_URL;
export var TabBlog = function () {
    var blogUrl = utilLoca.get(IdLoca.settingsMenu_blog_url);
    var iframeUrl = defaultBlogUrl;
    if (blogUrl !== "NONE") {
        iframeUrl = blogUrl.replace("blg", "blog");
    }
    // add version as qurey param to always burst cache of iframe
    iframeUrl = iframeUrl + "?v=" + utilBlog.getVersion();
    return (React.createElement("div", { className: "w100 h100 pl__large" },
        React.createElement("iframe", { src: iframeUrl, className: "w100 h100", style: iframeStyle })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/settings/TabBlog.tsx
// module id = 2746
// module chunks = 3